/**
 * Maui Next.js fetch cache tags.
 * These are used to tag fetch() calls in Maui so they can be invalidated
 * on-demand via Next.js revalidateTag — they are unrelated to Sanity or Redis cache.
 */

export const GROWTH_SDK_TAG = 'growth-sdk';
export const USER_COUNTRY = `${GROWTH_SDK_TAG}:user-country-by-ip`;

export const mauiFetchTags = [USER_COUNTRY];
